export enum InteractionEvent {
  SALES_ACTION_CLICKED = 'sales_action_clicked',
}
